//State
import {GETJOBS} from '../utility/constants'
export default function(state=null,action){
  
  switch (action.type) {
    case GETJOBS:
        return action.payload;
        
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducer/get_jobs.js